import { computed } from '@ember/object';
import { bool, mapBy } from '@ember/object/computed';
import { attr } from '@ember-data/model';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { isNone } from '@ember/utils';
import BaseFragment from '@square/dashboard-data/models/ember-data-base-fragment';
import Money from '@square/dashboard-money/models/money';
export default BaseFragment.extend({
  chargeNumber: attr('number'),
  description: attr('string'),
  amount: attr('money-proto', {
    defaultValue: () => Money.zero()
  }),
  taxAmount: attr('money-proto', {
    defaultValue: () => Money.zero()
  }),
  tax: fragment('squareup/inventory/v3/catalog-object-fee'),
  associatedLines: fragmentArray('squareup/inventory/v3/purchase-order-charge-associated-line'),
  hasTax: bool('tax'),
  updateTaxAmount: computed('tax.{amount,percentage}', 'taxAmount', 'amount', 'hasDirtyAttributes', function () {
    const amount = this.amount;
    const taxPercentage = this.tax?.percentage;
    let taxAmount = this.tax?.amount;
    if (taxPercentage) {
      if (amount) {
        taxAmount = amount.multiply(taxPercentage / 100);
      } else {
        taxAmount = null;
      }
    }
    if (!isNone(taxAmount) && !taxAmount.equals(this.taxAmount)) {
      // eslint-disable-next-line ember/no-side-effects
      this.set('taxAmount', taxAmount);
    }
    return true;
  }),
  amountWithTax: computed('amount', 'hasTax', 'taxAmount', function () {
    if (this.hasTax) {
      return this.amount.add(this.taxAmount);
    }
    return this.amount;
  }),
  associatedLineNumbers: mapBy('associatedLines', 'lineNumber')
}).reopenClass({
  _modelNameForMigration: 'squareup/inventory/v3/purchase-order-charge'
});